<script>
    import BreadcrumbsService from '../../app-front/services/api/BreadcrumbsService';

    export default {
        name: "AppBreadcrumbs",
        data(){
            return {
                breadcrumbs:[]
            }
        },
        methods: {
            getBreadcrumbs(){
                BreadcrumbsService.setLocale(this.$store.state.language.appLanguage);
                const params = {};
                params.name = this.breadcrumbsData.page || '';

                if(!params.name) return false;

                if(this.breadcrumbsData.data) {
                    params.data = this.breadcrumbsData.data;
                }

                return BreadcrumbsService.getBreadcrumbs(params);
            },

            setBreadcrumbs() {
                if(!this.breadcrumbsData) return false;

                this.getBreadcrumbs()
                    .then(res => {
                        this.breadcrumbs = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    });

            },
        },
        mounted(){
            this.setBreadcrumbs();
        }
    }
</script>

<style scoped>

</style>
